import { get_token, get_user_details } from "@/router";
import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/HomeNavBar/HomeNavBar.vue';

import Swal from 'sweetalert2';
import GlobalTable from '@/components/GlobalComponents/Tables/TableComponent.vue';
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';
import { view_profile as view_profile_helper } from "@/views/Feed/feed_helper.js";


export default {
  components: {
    Sidebar,
    Navbar,
    GlobalTable,
    InactivityModal
  },
  data() {
    return ({
      first_name: '',
      last_name: '',
      email: '',
      user_role: '',
      phone_number: '',
      roles: [],
      users: [],
      errors: {},
      logged_in_user_id: null,
      edit_form: {
        user_id: null,
        first_name: '',
        last_name: '',
        phone_number: '',
        email: '',
        user_role: '',
        searchTerm: '',
        isLoading: false,
      },
      active_tab: 'users',
      user_dashboard_filter: 'all',
    });
  },
  mounted() {
    this.fetch_users().then(() => {
      this.refresh_user_tables();
    })
    this.fetch_roles()
    const saved_tab = localStorage.getItem('active_tab');
    if (saved_tab) {
      this.active_tab = saved_tab;
    }
  },
  computed: {
    sanitizedUsers() {
      return this.filteredUsers.map(user => ({
        ...user,
        first_name: user.first_name || '',
        last_name: user.last_name || '',
        email: user.email || '',
        phone_number: user.phone_number || '',
      }));
    },
    filteredUsers() {
      return this.get_filtered_users_for_dashboard(this.users);
    },

    filteredAdmin() {
      return this.users.filter(user => this.get_user_role_name(user) === 'admin')
    },
    filteredClient() {
      return this.users.filter(user => user.role.role === 'client')
    },
    filteredCustomer() {
      return this.users.filter(user => this.get_user_role_name(user) === 'user')
    },
    filteredStakeholder() {
      return this.users.filter(user => user.role.role === 'stakeholder')
    },
    filteredEditor() {
      return this.users.filter(user => user.role.role === 'editor')
    },
    user_dashboard_cards() {
      return [
        { label: 'Total users', value: this.users.length, icon: 'bi-people-fill', tone: 'primary', tab: 'users', filter: 'all' },
        { label: 'Admins', value: this.filteredAdmin.length, icon: 'bi-shield-lock-fill', tone: 'danger', tab: 'admin', filter: 'all' },
        { label: 'Users', value: this.filteredCustomer.length, icon: 'bi-person-fill', tone: 'success', tab: 'user', filter: 'all' },
        { label: 'Active', value: this.active_user_count, icon: 'bi-person-check-fill', tone: 'info', tab: 'users', filter: 'active' },
        { label: 'Inactive', value: this.inactive_user_count, icon: 'bi-person-x-fill', tone: 'secondary', tab: 'users', filter: 'inactive' },
      ];
    },

    active_user_count() {
      return this.users.filter(user => user.is_active).length;
    },
    inactive_user_count() {
      return this.users.length - this.active_user_count;
    },
  },


  methods: {

    initDataTable(id) {
      const table = $(id)

      if (!table.length) return

      // Destroy if already initialised
      if ($.fn.DataTable.isDataTable(id)) {
        table.DataTable().destroy()
      }

      table.DataTable({
        paging: true,
        searching: true,
        ordering: true,
        info: true,
        lengthChange: true,
        pageLength: 10,
        language: {
          paginate: {
            previous: "Previous",
            next: "Next"
          },
          info: "Showing _START_ to _END_ of _TOTAL_ entries",
          infoEmpty: "No entries available"
        }
      })
    },

    exportToCSV() {
      if (!this.users || this.users.length === 0) {
        Swal.fire({
          icon: 'warning',
          text: 'No members selected for export.',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        return;
      }
      const csvHeader = "Name,Last Name ,Email,Phone number,Role\n";
      const csvRows = this.users.map(user =>
        `${user.first_name},${user.last_name},${user.email},${user.phone_number},${user.role.role}`
      );

      const csvContent = csvHeader + csvRows.join("\n");
      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "users.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    getToken() {
      return get_token();
    },

    get_user_role_name(user) {
      return String(user?.role?.role || user?.role || 'unknown').trim();
    },
    get_filtered_users_for_dashboard(users) {
      const filters = {
        active: user => user.is_active,
        inactive: user => !user.is_active,
      };
      const filter = filters[this.user_dashboard_filter];

      return filter ? users.filter(filter) : users;
    },
    handle_user_dashboard_card_click(card) {
      this.user_dashboard_filter = card.filter || 'all';
      this.setactive_tab(card.tab || 'users', false);
    },
    is_user_dashboard_card_active(card) {
      const card_filter = card.filter || 'all';
      const card_tab = card.tab || 'users';

      return this.active_tab === card_tab && this.user_dashboard_filter === card_filter;
    },
    refresh_user_tables() {
      this.$nextTick(() => {
        this.initDataTable(this.get_active_user_table_id());
      });
    },
    destroy_user_tables() {
      ['#usersTable', '#adminTable', '#NormalUsersTable'].forEach((id) => {
        if ($.fn.DataTable.isDataTable(id)) {
          $(id).DataTable().destroy();
        }
      });
    },
    get_active_user_table_id() {
      const tables = {
        admin: '#adminTable',
        user: '#NormalUsersTable',
        users: '#usersTable',
      };

      return tables[this.active_tab] || tables.users;
    },
    setactive_tab(tab, reset_filter = true) {
      this.destroy_user_tables();
      this.active_tab = tab;
      if (reset_filter) {
        this.user_dashboard_filter = 'all';
      }
      // Save the active tab to localStorage
      localStorage.setItem('active_tab', tab);
      this.refresh_user_tables();
    },
    toggleSidebar() {
      this.$refs.sidebar.$el.classList.toggle("close");
    },
    view_user_profile(user) {
      view_profile_helper(this.$router, user);
    },

    validationUserForm() {
      this.errors = {};
      let valid = true;
      // const form = form_type === 'edit' ? this.edit_form : this;

      if (!this.first_name) {
        this.errors.first_name = 'First name is required.';
        valid = false;
      } else if (this.first_name.length < 3) {
        this.errors.first_name = 'First name must be at least 3 characters long.';
        valid = false;
      } else if (/[^a-zA-Z\s]/.test(this.first_name)) {
        this.errors.first_name = 'First name must only contain letters and spaces.';
        valid = false;
      }
      if (!this.last_name) {
        this.errors.last_name = 'Last name is required.';
        valid = false;
      } else if (this.last_name.length < 3) {
        this.errors.last_name = 'Last name must be at least 3 characters long.';
        valid = false;
      } else if (/[^a-zA-Z\s]/.test(this.last_name)) {
        this.errors.last_name = 'Last name must only contain letters and spaces.';
        valid = false;
      }
      if (!this.email.trim()) {
        this.errors.email = 'Email is required.';
        valid = false;
      } else if (!/\S+@\S+\.\S+/.test(this.email)) {
        this.errors.email = 'Please enter a valid email address.';
        valid = false;
      }
      if (!this.user_role) {
        this.errors.user_role = 'User role is required.';
        valid = false;
      }

      return valid;
    },

    submit_form() {
      if (!this.validationUserForm('create')) {
        return;
      }
      Swal.fire({
        title: 'Saving...',
        text: 'Please wait while we save the user data.',
        allowOutsideClick: false,
        showConfirmButton: false,
        onOpen: () => {
          Swal.showLoading();
        }
      });

      const protocol = window.location.protocol;
      const host = window.location.host;
      var login_url = `${protocol}//${host}/login`;

      const data = {
        email: this.email,
        role: this.user_role,
        login_url: login_url,
        last_name: this.last_name,
        first_name: this.first_name,
        phone_number: this.phone_number,
      };

      $.ajax({
        type: 'POST',
        url: process.env.VUE_APP_BACKEND_API_URL + '/system_management/create_user/',
        data: JSON.stringify(data),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          const status = response.status;

          if (status === "success") {
            const updated_user = response?.data?.user_data;
            if (updated_user?.id) {
              this.users = this.users.map((user) => {
                if (user.id !== updated_user.id) {
                  return user;
                }

                return {
                  ...user,
                  ...updated_user,
                };
              });
            }
            Swal.fire({
              icon: "success",
              title: "User Created",
              showConfirmButton: false,
              timer: 1000,
              position: 'bottom-end',
              toast: true
            });
            this.resetForm();
            $('#create_user').modal('hide');
          }
        },
        error: (response) => {
          const response_data = response.responseJSON
          Swal.close()
          if (response_data.status == 'error') {
            const message = response_data.message.toLowerCase();
            if (message.includes('email')) {
              this.errors.email = response_data.message;
            } else if (message.includes('phone number')) {
              this.errors.phone_number = response_data.message;
            }

          }

        }
      });
    },

    resetForm() {
      this.first_name = '';
      this.last_name = '';
      this.email = '';
      this.phone_number = '';
      this.user_role = '';
      this.errors = {};
    },

    fetch_users() {
      this.isLoading = true;
      return new Promise((resolve) => {
        $.ajax({
          type: 'GET',
          url: process.env.VUE_APP_BACKEND_API_URL + '/system_management/retrieve_users/',
          data: { email: this.$route.query.email },
          headers: {
            'Authorization': `Token ${this.getToken()}`,
          },
          success: (response) => {
            this.users = response.data.users_list;
            const logged_in_user = get_user_details();
            this.isLoading = false;

            if (logged_in_user) {
              this.logged_in_user_id = logged_in_user.user_id;
            }
            resolve();
          },
        });
      });
    },


    fetch_roles() {
      $.ajax({
        type: 'GET',
        url: process.env.VUE_APP_BACKEND_API_URL + '/system_management/get_roles/',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {
          const response_roles = response.data;
          this.roles = response_roles.role_data;
        },
      });
    },

    confirm_deactivation(user_id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, deactivate it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.deactivate_user(user_id);
        }
      });
    },

    deactivate_user(user_id) {
      $.ajax({
        type: 'POST',
        url: process.env.VUE_APP_BACKEND_API_URL + '/system_management/deactivate_user/',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: {
          user_id: user_id
        },
        success: (response) => {
          const status = response.status;
          const message = response.message;

          if (status === "success") {
            const updated_user = response?.data?.user_data;
            if (updated_user?.id) {
              this.users = this.users.map((user) => {
                if (user.id !== updated_user.id) {
                  return user;
                }

                return ({
                  ...user,
                  ...updated_user,
                });
              });
            }
            const user = this.users.find(u => u.id === user_id);
            if (user) {
              user.is_active = false;
            }
            Swal.fire({
              icon: "success",
              title: "Success",
              showConfirmButton: false,
              timer: 1000,
              position: 'bottom-end',
              toast: true
            })

          } else if (status === "error") {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: message,
              confirmButtonText: "OK",
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          }
        },
        error: () => {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "There was a problem deactivating the user. Please try again.",
            confirmButtonText: "OK",
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        }
      });
    },

    confirm_activation(user_id) {
      Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, activate it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.activate_user(user_id);
        }
      });
    },

    activate_user(user_id) {
      const protocol = window.location.protocol;
      const host = window.location.host;
      this.login_url = `${protocol}//${host}/login`;
      $.ajax({
        type: 'POST',
        url: process.env.VUE_APP_BACKEND_API_URL + '/system_management/activate_user/',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: { user_id: user_id, login_url: this.login_url },
        success: (response) => {
          const status = response.status;
          const message = response.message;

          if (status === "success") {
            const updated_user = response?.data?.user_data;
            if (updated_user?.id) {
              this.users = this.users.map((user) => {
                if (user.id !== updated_user.id) {
                  return user;
                }

                return ({
                  ...user,
                  ...updated_user,
                });
              });
            }
            const user = this.users.find(u => u.id === user_id);
            if (user) {
              user.is_active = true;
            }
            Swal.fire({
              icon: "success",
              title: "Success",
              showConfirmButton: false,
              timer: 1000,
              position: 'bottom-end',
              toast: true
            })
          } else if (status === "error") {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: message,
              confirmButtonText: "OK",
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          }
        },
        error: () => {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "There was a problem activating the user. Please try again.",
            confirmButtonText: "OK",
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        }
      });
    },

    edit_user(user) {
      this.edit_form = {
        user_id: user.id,
        first_name: user.first_name,
        last_name: user.last_name,
        phone_number: user.phone_number,
        email: user.email,
        user_role: user.role.role
      };
      this.reset_errors();
      $('#edit_user').modal('show');
    },

    update_user() {

      Swal.fire({
        title: 'Updating...',
        text: 'Please wait while we update the user data.',
        allowOutsideClick: false,
        showConfirmButton: false,
        onOpen: () => {
          Swal.showLoading();
        }
      });

      const data = {
        user_id: this.edit_form.user_id,
        first_name: this.edit_form.first_name,
        last_name: this.edit_form.last_name,
        email: this.edit_form.email,
        phone_number: this.edit_form.phone_number,
        role: this.edit_form.user_role
      };
      $.ajax({
        type: 'POST',
        url: process.env.VUE_APP_BACKEND_API_URL + '/system_management/update_user/',
        data: JSON.stringify(data),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          const status = response.status;
          const message = response.message;

          if (status === "success") {
            const updated_user = response?.data?.user_data;
            if (updated_user?.id) {
              this.users = this.users.map((user) => {
                if (user.id !== updated_user.id) {
                  return user;
                }

                return ({
                  ...user,
                  ...updated_user,
                });
              });
            }
            Swal.fire({
              icon: "success",
              title: "User Updated",
              showConfirmButton: false,
              timer: 1000,
              position: 'bottom-end',
              toast: true
            });
            $('#edit_user').modal('hide');
          } else if (status === "error") {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: message,
              confirmButtonText: "OK",
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          }
        },
        error: (response) => {
          const status = response.responseJSON.status
          Swal.close();
          if (status === 'error') {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response.responseJSON.message,
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            });
          }
        }
      });
    },

    reset_edit_form() {
      this.edit_form = {
        user_id: null,
        first_name: '',
        last_name: '',
        phone_number: '',
        email: '',
        user_role: ''
      };
      this.reset_errors();
    },

    reset_errors() {
      this.errors = {};
    },

    delete_user(user_id) {
      Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Continue',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {

          const request_data = JSON.stringify({ user_id: user_id });

          const headers = {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          };

          const url = `${process.env.VUE_APP_BACKEND_API_URL}/system_management/delete_user/`;

          $.ajax({
            type: 'DELETE',
            url: url,
            headers: headers,
            data: request_data,
            contentType: 'application/json',
            success: (response) => {

              const status = response.status;

              if (status === "success") {
            const updated_user = response?.data?.user_data;
            if (updated_user?.id) {
              this.users = this.users.map((user) => {
                if (user.id !== updated_user.id) {
                  return user;
                }

                return ({
                  ...user,
                  ...updated_user,
                });
              });
            }
                this.users = this.users.filter(user => user.id !== user_id);
                Swal.fire(
                  {
                    icon: 'success',
                    title: 'User deleted',
                    showConfirmButton: false,
                    timer: 2000,
                    position: 'bottom-end',
                    toast: true
                  }
                );
              } else {
                Swal.fire({
                  icon: 'error',
                  title: 'Sorry',
                  text: 'Could not delete user.',
                  confirmButtonText: 'OK',
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
                });
              }
            },
            error: () => {
              Swal.fire({
                icon: 'error',
                title: 'Sorry',
                text: 'Could not delete user.',
                confirmButtonText: 'OK',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          });
        }
      });
    },

  }
};
